import {Injectable} from "@angular/core";
import {Device} from "../domain/model/device";

@Injectable({
  providedIn: 'root',
})
export abstract class DeviceDAO {
  abstract notSentDevice(): Device | null;
  abstract create(deviceId: string): void;
  abstract update(deviceId: string,isSent: boolean): void;
  abstract exists(deviceId: string): boolean;
}
